export default __webpack_public_path__ + "static/media/ni.56e96860.jpg";